import { useState } from "react";
import { scenarioAddWidget, zoneWidgets } from "../../api";
import Cookies from "js-cookie";
import { useEffect } from "react";
import { Alert } from "../Alert";
import { useTranslation } from "react-i18next";
import { FiPower, FiChevronDown, FiChevronUp, FiMapPin, FiCircle, FiX, FiCheck } from "react-icons/fi";

const token = Cookies.get("token");

const ScenariosWidgets = ({
  id,
  titleEdit,
  setScenarioCommand,
  scenarioId,
  zoneCaption,
}) => {
  const { t } = useTranslation();
  const [dashboardDetail, setDashboardDetail] = useState([]);
  const [title, setTitle] = useState(titleEdit);
  const [showAlert, setShowAlert] = useState({
    show: false,
    message: "",
    type: "",
  });
  const [widgetIndex, setWidgetIndex] = useState("");
  const [widgetId, setWidgetId] = useState("");
  const [showToast, setShowToast] = useState(false);
  const [tooltipText, setTooltipText] = useState("");
  const [isClicked, setIsClicked] = useState(false);
  const [expandedWidgets, setExpandedWidgets] = useState({});
  const [selectedItems, setSelectedItems] = useState([]); // لیست آیتم‌های انتخاب شده

  const toggleAlert = () => {
    setShowAlert((prevState) => ({
      ...prevState,
      show: false,
    }));
  };

  useEffect(() => {
    setDashboardDetail([]);
    var data = new FormData();
    data.append("zone", id);
    zoneWidgets(data, token)
      .then((result) => {
        setDashboardDetail(result.data.data);
      })
      .catch((error) => {
        if (error.response.status === 403) {
          setShowAlert({
            show: true,
            message: t("خطایی رخ داده است . لطفا مجددا امتحان کنید."),
            type: "Error",
          });
          setTimeout(() => {
            setShowAlert((prev) => ({ ...prev, show: false }));
          }, 2000);
        }
      });
  }, []);

  // بررسی اینکه آیا آیتم قبلاً انتخاب شده است
  const isItemSelected = (caption, command) => {
    return selectedItems.some(
      (item) => item.caption === caption && item.command === command
    );
  };

  const handleOnOffWidget = (caption, command, id, serial) => {
    const commandText = command === "10" ? t("روشن") : t("خاموش");
    const itemKey = `${caption}_${command}`;
    
    // اگر آیتم قبلاً انتخاب شده بود، حذف کن
    if (isItemSelected(caption, command)) {
      // حذف از selectedItems
      setSelectedItems(prev => prev.filter(
        item => !(item.caption === caption && item.command === command)
      ));
      // حذف از scenarioCommand
      setScenarioCommand((prev) => {
        return prev.filter(
          (item) => !(item.caption.caption === caption && item.command.command === command)
        );
      });
      
      setShowAlert({
        show: true,
        question: false,
        message: caption + t(" با موفقیت حذف شد."),
        type: "Warning",
      });
    } else {
      // اضافه کردن به selectedItems
      setSelectedItems(prev => [
        ...prev,
        { caption, command: commandText, commandValue: command, id, serial }
      ]);
      // اضافه کردن به scenarioCommand
      setScenarioCommand((prev) => {
        return [
          ...prev,
          {
            caption: { caption },
            command: { command },
            id: { id },
            serial: { serial },
          },
        ];
      });
      
      setShowAlert({
        show: true,
        question: false,
        message: caption + t(" با موفقیت اضافه شد."),
        type: "Success",
      });
    }
    
    setTimeout(() => {
      setShowAlert((prev) => ({ ...prev, show: false }));
    }, 2000);
    setTimeout(() => {
      setShowToast(false);
      setTooltipText("");
    }, 2000);
    setIsClicked(true);
  };

  // حذف آیتم از لیست انتخاب شده
  const removeSelectedItem = (index) => {
    const item = selectedItems[index];
    setSelectedItems(prev => prev.filter((_, i) => i !== index));
    setScenarioCommand((prev) => {
      return prev.filter(
        (item) => !(item.caption.caption === item.caption && item.command.command === (item.commandValue === t("روشن") ? "10" : "11"))
      );
    });
    
    setShowAlert({
      show: true,
      question: false,
      message: item.caption + t(" با موفقیت حذف شد."),
      type: "Warning",
    });
    setTimeout(() => {
      setShowAlert((prev) => ({ ...prev, show: false }));
    }, 2000);
  };

  const toggleWidgetExpand = (index) => {
    setExpandedWidgets((prev) => ({
      ...prev,
      [index]: !prev[index],
    }));
    setWidgetIndex(index);
    setWidgetId(dashboardDetail[index]?.id);
    setIsClicked(false);
  };

  const isOnCommand = (command) => {
    return command === "10";
  };

  return (
    <div className="scenarios-widgets-container">
      {/* Header */}
      <div className="scenarios-widgets-header">
        <div className="scenarios-widgets-icon">
          <FiMapPin size={20} />
        </div>
        <h3 className="scenarios-widgets-title">{t("انتخاب رویدادها")}</h3>
      </div>

      {/* Zone Info */}
      <div className="scenarios-widgets-zone">
        <span className="scenarios-widgets-zone-label">{t("ناحیه")}</span>
        <span className="scenarios-widgets-zone-name">{zoneCaption}</span>
      </div>

      {/* Selected Items List */}
      {selectedItems.length > 0 && (
        <div className="scenarios-widgets-selected">
          <div className="scenarios-widgets-selected-header">
            <FiCheck size={14} />
            <span>{t("رویدادهای انتخاب شده")}</span>
            <span className="scenarios-widgets-selected-count">
              {selectedItems.length}
            </span>
          </div>
          <div className="scenarios-widgets-selected-list">
            {selectedItems.map((item, idx) => (
              <div key={idx} className="scenarios-widgets-selected-item">
                <div className="scenarios-widgets-selected-item-info">
                  <span className="scenarios-widgets-selected-item-name">
                    {item.caption}
                  </span>
                  <span className={`scenarios-widgets-selected-item-command ${item.command === t("روشن") ? "on" : "off"}`}>
                    {item.command}
                  </span>
                </div>
                <button
                  className="scenarios-widgets-selected-item-remove"
                  onClick={() => removeSelectedItem(idx)}
                >
                  <FiX size={14} />
                </button>
              </div>
            ))}
          </div>
        </div>
      )}

      <p className="scenarios-widgets-description">
        {t("رویداد های مورد نظر خود را انتخاب نمایید")}
      </p>

      {/* Widgets List */}
      <div className="scenarios-widgets-list">
        {dashboardDetail?.map((item, index) => {
          const isExpanded = expandedWidgets[index];
          const isActive = widgetIndex === index;
          
          return (
            <div key={index} className="scenarios-widgets-item">
              <div
                className={`scenarios-widgets-item-header ${isActive ? "active" : ""}`}
                onClick={() => toggleWidgetExpand(index)}
              >
                <div className="scenarios-widgets-item-info">
                  <div className="scenarios-widgets-item-icon">
                    {isExpanded ? <FiChevronUp size={16} /> : <FiChevronDown size={16} />}
                  </div>
                  <span className="scenarios-widgets-item-name">{item.caption}</span>
                </div>
              </div>
              
              {isExpanded && item.commands && (
                <div className="scenarios-widgets-item-commands">
                  {item.commands.map((cmd, cmdIndex) => {
                    const isSelected = isItemSelected(item.caption, cmd.command);
                    return (
                      <button
                        key={cmdIndex}
                        className={`scenarios-widgets-command-btn ${isSelected ? "selected" : ""}`}
                        onClick={() =>
                          handleOnOffWidget(
                            item.caption,
                            cmd.command,
                            item.id,
                            item.serial
                          )
                        }
                      >
                        {isOnCommand(cmd.command) ? (
                          <>
                            <FiPower size={14} />
                            <span>{t("روشن")}</span>
                          </>
                        ) : (
                          <>
                            <FiCircle size={14} />
                            <span>{t("خاموش")}</span>
                          </>
                        )}
                        {isSelected && <FiCheck size={12} className="selected-check" />}
                      </button>
                    );
                  })}
                </div>
              )}
            </div>
          );
        })}
      </div>

      {tooltipText && <div className="toast-tooltip">{tooltipText}</div>}
      
      {showAlert.show && (
        <Alert
          message={showAlert.message}
          type={showAlert.type}
          title={title}
          question={showAlert.question}
          request={showAlert.request}
          toggleAlert={toggleAlert}
        />
      )}
    </div>
  );
};

export { ScenariosWidgets };